module.exports = "pegasus/assets/square-linkedin.gif";